import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };

  static environment: HostEnvironment = 'dev';
  static disable_spotlights = false;
  static palfinger_api_management = '';
  static palfinger_api_management_subs_key = '';
  static palfinger_app_gateway = '';
  static palfinger_app_gateway_v2 = '';
  static oidc_clientid = '';
  static oidc_scope =
    'openid profile identity.userprofile ms.bpm palfinger.telematics.provisioning ms.search';
  static google_analytics_id = '';

  static domainsForApiManagementSubsKey: string[];
  static application_insights_key = '';

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    DANFOSS_STATUS_PAGE: string;
    PALDESK_BASEPATH: string;
    STATUS_PALDESK_PAGE: string;
    EQUIPMENT_SCREEN_PAGE: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    DANFOSS_STATUS_PAGE: '',
    PALDESK_BASEPATH: '',
    STATUS_PALDESK_PAGE: '',
    EQUIPMENT_SCREEN_PAGE: '',
  };

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
  };
}
